export default {"src":"/_next/static/media/reddit.bbf7e1b0.svg","height":2500,"width":2500};